import { apiInstance } from '@shared/api'

export const postAccount = async (body: RegisterAccountRequest) => {
  const res = await apiInstance.post<RegisterAccountResponse>('/api/v1/account', body)
  return res.data
}

export const getAccount = async () => {
  const res = await apiInstance.get<AccountListResponse>('/api/v1/account')
  return res.data
}

export const deleteAccount = async (body: DeleteAccountRequest) => {
  const res = await apiInstance.delete<ApiResponse>('/api/v1/account', { data: body })
  return res.data
}

export const getAccountAssets = async () => {
  const res = await apiInstance.get<AccountAssetsResponse>('/api/v1/account/assets')
  return res.data
}

export const postAccountAllocationRatio = async (body: SetAllocationRatioRequest) => {
  const res = await apiInstance.post<ApiResponseBase>('/api/v1/account/allocationRatio', body)
  return res.data
}

export const postAccountReload = async () => {
  const res = await apiInstance.post<ApiResponseBase>('/api/v1/account/reload')
  return res.data
}
